import {
  showErrorMessage,
  showSuccessMessage,
} from "../components/presentation/common/snackbar";
import API, {
  CoreAPI,
  CrmCompanyAPI,
  CrmContactAPI,
  portalBaseUrl,
  PortalCompanyAPI,
  userAPI,
} from "../config";
import { errorMessage, successMessage } from "../utils/responseMessage";
import { setCompressedSessionItem } from "../utils/compressedSessionStorage";
import { showSuccessError, showPageLoader, hidePageLoader } from "./common";

const userData =
  sessionStorage.getItem("loggedUserData") &&
  JSON.parse(sessionStorage.getItem("loggedUserData")).user_data;

export const getAllCompanies = (params) => (dispatch) => {
  dispatch({
    type: "GET_ALL_COMPANIES_LOADING",
    payload: true,
  });
  CrmCompanyAPI.get("/companies/filter", { params })
    .then((response) => {
      dispatch({
        type: "GET_ALL_COMPANIES",
        payload: response.data,
      });
      dispatch({
        type: "GET_ALL_COMPANIES_LOADING",
        payload: false,
      });
    })
    .catch(function (error) {
      showErrorMessage(errorMessage(error));
      dispatch({
        type: "GET_ALL_COMPANIES_LOADING",
        payload: false,
      });
    });
};

export const getReferenceData = () => (dispatch) => {
  CoreAPI.get(`/core/reference-data`)
    .then((response) => {
      dispatch({
        type: "GET_REFERENCE_DATA",
        payload: response?.data,
      });
      setCompressedSessionItem("referenceData", response?.data);
    })
    .catch(function (error) {
      showErrorMessage(errorMessage(error));
    });
};

export const createCompany =
  ({ data, history }) =>
  (dispatch) => {
    dispatch({
      type: "CREATE_COMPANY_LOADING",
      payload: true,
    });
    CrmCompanyAPI.post("/companies?external_data=false", data)
      .then((response) => {
        if (response.status) {
          dispatch({
            type: "CREATE_COMPANY_SUCCESS",
            payload: response.data,
          });
          dispatch({
            type: "CREATE_COMPANY_LOADING",
            payload: false,
          });
          if (history) {
            history.push("/my-clients");
          }
          showSuccessMessage(successMessage(response));
        }
      })
      .catch((error) => {
        dispatch({
          type: "CREATE_COMPANY_ERROR",
          payload: errorMessage(error),
        });
        dispatch({
          type: "CREATE_COMPANY_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const updateCompany =
  ({ companyId, data, setEditOpen }) =>
  (dispatch) => {
    dispatch({
      type: "UPDATE_COMPANY_LOADING",
      payload: true,
    });
    CrmCompanyAPI.put(`/companies/${companyId}`, data)
      .then((response) => {
        if (response.status) {
          dispatch({
            type: "UPDATE_COMPANY_SUCCESS",
            payload: response.data,
          });
          dispatch({
            type: "UPDATE_COMPANY_LOADING",
            payload: false,
          });
          setEditOpen?.(false);
          showSuccessMessage(successMessage(response));
        }
        CrmCompanyAPI.get(`/companies/${companyId}`).then((response) => {
          dispatch({
            type: "GET_COMPANY_DETAILS_SUCCESS",
            payload: response.data,
          });
        });
      })
      .catch((error) => {
        dispatch({
          type: "UPDATE_COMPANY_ERROR",
          payload: errorMessage(error),
        });
        dispatch({
          type: "UPDATE_COMPANY_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const getCompanyContact = (params) => (dispatch) => {
  dispatch({
    type: "GET_COMPANY_CONTACT_LOADING",
    payload: true,
  });
  CrmCompanyAPI.get(`/contacts`, { params })
    .then((response) => {
      dispatch({
        type: "GET_COMPANY_CONTACT_SUCCESS",
        payload: response.data,
      });
      dispatch({
        type: "GET_COMPANY_CONTACT_LOADING",
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: "GET_COMPANY_CONTACT_ERROR",
        payload: errorMessage(error),
      });
      dispatch({
        type: "GET_COMPANY_CONTACT_LOADING",
        payload: false,
      });
      showErrorMessage(errorMessage(error));
    });
};

export const getSingleContact =
  ({ contactId }) =>
  (dispatch) => {
    dispatch({
      type: "GET_SINGLE_CONTACT_LOADING",
      payload: true,
    });
    CrmCompanyAPI.get(`/contacts/${contactId}`)
      .then((response) => {
        dispatch({
          type: "GET_SINGLE_CONTACT_SUCCESS",
          payload: response.data,
        });
        dispatch({
          type: "GET_SINGLE_CONTACT_LOADING",
          payload: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GET_SINGLE_CONTACT_ERROR",
          payload: errorMessage(error),
        });
        dispatch({
          type: "GET_SINGLE_CONTACT_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const updateContact =
  ({ data, contactId, companyId, setOpenDrawer, fromInvite }) =>
  (dispatch) => {
    dispatch({
      type: "UPDATE_CONTACT_LOADING",
      payload: true,
    });
    const userDetails =
      sessionStorage.getItem("loggedUserData") &&
      JSON.parse(sessionStorage.getItem("loggedUserData"));
    const party_business_id = userDetails?.user_data?.party_business?.id;
    CrmCompanyAPI.put(`/contacts/${contactId}`, data)
      .then((response) => {
        dispatch({
          type: "UPDATE_CONTACT_SUCCESS",
          payload: response.data,
        });
        dispatch(
          getCompanyContact({ party_business_id, company_id: companyId })
        );
        setOpenDrawer?.(false);
        dispatch({
          type: "UPDATE_CONTACT_LOADING",
          payload: false,
        });
        !fromInvite && showSuccessMessage(successMessage(response));
      })
      .catch((error) => {
        dispatch({
          type: "UPDATE_CONTACT_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const addContact =
  ({ data, setOpenDrawer, companyId }) =>
  (dispatch) => {
    dispatch({
      type: "ADD_CONTACT_LOADING",
      payload: true,
    });
    const userDetails =
      sessionStorage.getItem("loggedUserData") &&
      JSON.parse(sessionStorage.getItem("loggedUserData"));
    const party_business_id = userDetails?.user_data?.party_business?.id;
    CrmCompanyAPI.post(`/contacts`, data)
      .then((response) => {
        dispatch({
          type: "ADD_CONTACT_SUCCESS",
          payload: response.data,
        });
        setOpenDrawer?.(false);
        dispatch(
          getCompanyContact({ party_business_id, company_id: companyId })
        );
        dispatch({
          type: "ADD_CONTACT_LOADING",
          payload: false,
        });
        showSuccessMessage(successMessage(response));
      })
      .catch((error) => {
        dispatch({
          type: "ADD_CONTACT_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const activePortalUser =
  ({ payload, invoffUserId }) =>
  (dispatch) => {
    dispatch({
      type: "ACTIVE_PORTAL_USER_LOADING",
      payload: true,
    });
    portalBaseUrl
      .put(`/user/user-profile/${invoffUserId}`, payload)
      .then((response) => {
        dispatch({
          type: "ACTIVE_PORTAL_USER_SUCCESS",
          payload: response.data,
        });
        dispatch({
          type: "ACTIVE_PORTAL_USER_LOADING",
          payload: false,
        });
        showSuccessMessage(successMessage(response));
      })
      .catch((error) => {
        dispatch({
          type: "ACTIVE_PORTAL_USER_ERROR",
          payload: errorMessage(error),
        });
        dispatch({
          type: "ACTIVE_PORTAL_USER_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const getPortalUserInfo = (userId) => (dispatch) => {
  CrmCompanyAPI.get(`customer-portal/user/user-profile?contact_id=${userId}`)
    .then((response) => {
      dispatch({
        type: "GET_PORTAL_USER_INFO",
        payload: response.data,
      });
    })
    .catch((error) => {
      showErrorMessage(errorMessage(error));
    });
};

export const getCrmCompanyDetails = (companyId) => (dispatch) => {
  dispatch({
    type: "GET_COMPANY_DETAILS_LOADING",
    payload: true,
  });
  CrmCompanyAPI.get(`/companies/${companyId}`)
    .then((response) => {
      dispatch({
        type: "GET_COMPANY_DETAILS_SUCCESS",
        payload: response.data,
      });
      dispatch({
        type: "GET_COMPANY_DETAILS_LOADING",
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: "GET_COMPANY_DETAILS_LOADING",
        payload: false,
      });
      showErrorMessage(errorMessage(error));
    });
};

export const getRegions = () => (dispatch) => {
  showPageLoader(dispatch);

  API.get(`ref-all-region?current_user=${userData?.id}`)
    .then((response) => {
      if (response.data.status) {
        dispatch({
          type: "GET_REGIONS",
          payload: response.data.data,
        });
      } else {
        // dispatch(showSuccessError(response.data));
      }
    })
    .catch(function (error) {
      // dispatch(showSuccessError(error));
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const getCountries = (countryId) => (dispatch) => {
  CoreAPI.get(`/core/reference-data/countries`)
    .then((response) => {
      dispatch({
        type: "GET_COUNTRIES",
        payload: response.data,
      });
    })
    .catch(function (error) {
      showErrorMessage(errorMessage(error));
    });
};

export const getStates = (countryId) => (dispatch) => {
  CoreAPI.get(`/core/reference-data/states?country_id=${countryId}`)
    .then((response) => {
      dispatch({
        type: "GET_STATES",
        payload: response.data,
      });
    })
    .catch(function (error) {
      showErrorMessage(errorMessage(error));
    });
};

export const getCities = (stateId) => (dispatch) => {
  showPageLoader(dispatch);
  CoreAPI.get(`/core/reference-data/cities?state_id=${stateId}`)
    .then((response) => {
      dispatch({
        type: "GET_CITIES",
        payload: response.data,
      });
    })
    .catch(function (error) {
      showErrorMessage(errorMessage(error));
    });
};

export const getAddressLookup =
  ({ postcode }) =>
  (dispatch) => {
    dispatch({
      type: "ADDRESS_LOOKUP_LOADING",
      payload: true,
    });
    CrmCompanyAPI.get(`/companies/postcode-search?postcode=${postcode}`)
      .then((response) => {
        dispatch({
          type: "ADDRESS_LOOKUP_SUCCESS",
          payload: response.data,
        });
        dispatch({
          type: "ADDRESS_LOOKUP_LOADING",
          payload: false,
        });
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "ADDRESS_LOOKUP_ERROR",
          payload: errorMessage(error),
        });
        dispatch({
          type: "ADDRESS_LOOKUP_LOADING",
          payload: false,
        });
      });
  };

export const addBusinessAreaServed = (data, flag, history) => (dispatch) => {
  showPageLoader(dispatch);
  API.post(`add-business-areaserved?current_user=${userData?.id}`, data)
    .then((response) => {
      if (response.data.status) {
        dispatch({
          type: "ADD_BUSINESS_AREASERVED",
          // payload: response.data,
        });

        flag === "submit"
          ? (window.location.href = "/home")
          : history.push("/profile-expertise");
      } else {
        // dispatch(showSuccessError(response.data));
      }
    })
    .catch(function (error) {
      dispatch(showSuccessError(error));
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

// action to get user profile data
export const getUserProfileData =
  (id, getImage = false) =>
  (dispatch) => {
    showPageLoader(dispatch);
    userAPI
      .get(`user/user-profile?invoffuserid=${id}`)
      .then((response) => {
        if (response.data.status) {
          dispatch({
            type: "GET_USER_PROFILE_DATA",
            payload: response.data,
          });
          if (getImage) {
            sessionStorage.setItem(
              "profile_pic",
              `${
                response.data.data && response.data.data.profile_pic?.document
              }`
            );
            window.location.reload();
          }
        } else {
          // dispatch(showSuccessError(response.data));
        }
      })
      .catch(function (error) {
        dispatch(showSuccessError(error));
      })
      .finally(function () {
        hidePageLoader(dispatch);
      });
  };

export const updateUserProfileData =
  (id, data, flag, setImageData) => (dispatch) => {
    if (flag === "profile_pic") {
      dispatch({
        type: "UPDATE_PROFILE_PIC_LOADING",
        payload: true,
      });
    }
    showPageLoader(dispatch);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    userAPI
      .put(`user/user-profile/${id}?current_user=${userData?.id}`, data, config)
      .then((response) => {
        if (response.data.status) {
          showSuccessMessage(successMessage(response));
          if (flag === "profile_pic") {
            setImageData("");
            if (
              response.data.data &&
              response.data.data.profile_pic?.document
            ) {
              sessionStorage.setItem(
                "profile_pic",
                `${response.data.data.profile_pic.document}`
              );
              const loggedUserData = JSON.parse(
                sessionStorage.getItem("loggedUserData")
              );
              if (loggedUserData && loggedUserData.user_data) {
                loggedUserData.user_data.profile_pic =
                  response.data.data.profile_pic.document;
                sessionStorage.setItem(
                  "loggedUserData",
                  JSON.stringify(loggedUserData)
                );
              }
            }
          }
          dispatch(getUserProfileData(id, true));
        } else {
          showErrorMessage(response.data.message || "Failed to update profile");
        }
      })
      .catch(function (error) {
        dispatch(showSuccessError(error));
        showErrorMessage(errorMessage(error));
      })
      .finally(function () {
        if (flag === "profile_pic") {
          dispatch({
            type: "UPDATE_PROFILE_PIC_LOADING",
            payload: false,
          });
        }
        hidePageLoader(dispatch);
      });
  };

// Expertise

export const getUserExpertise = (invoffuserid) => (dispatch) => {
  showPageLoader(dispatch);
  API.get(
    `user-industry-expertise?invoffuserid=${invoffuserid}&current_user=${userData?.id}`
  )
    .then((response) => {
      if (response.data.status) {
        dispatch({
          type: "GET_USER_EXPERTISE",
          payload: response.data.data,
        });
      } else {
        // dispatch(showSuccessError(response.data));
      }
    })
    .catch(function (error) {
      dispatch(showSuccessError(error));
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const getTimeZones = () => (dispatch) => {
  dispatch(showPageLoader());
  API.get(`ref-all-timezone?current_user=${userData?.id}`)
    .then((response) => {
      if (response.data.status) {
        dispatch({
          type: "GET_TIME_ZONES",
          payload: response.data.data,
        });
      } else {
        // dispatch(showSuccessError(response.data));
      }
    })
    .catch(function (error) {
      // dispatch(showSuccessError(error));
    })
    .finally(function () {
      dispatch(hidePageLoader());
    });
};

export const getCompanyDetails = (companyId) => (dispatch) => {
  dispatch(showPageLoader());
  dispatch({
    type: "COMPANY_LOADING",
    payload: true,
  });
  PortalCompanyAPI.get(`companies/${companyId}?external_data=true`)
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: "GET_COMPANY_DETAIL",
          payload: response.data,
        });
        dispatch({
          type: "COMPANY_LOADING",
          payload: false,
        });
      } else {
        dispatch({
          type: "COMPANY_LOADING",
          payload: false,
        });
      }
    })
    .catch(function (error) {
      dispatch({
        type: "COMPANY_LOADING",
        payload: false,
      });
    });
};

export const getFcaDetail =
  ({
    search_data,
    search_type,
    number,
    party_business_id,
    edit_flag,
    fetch_latest,
  }) =>
  (dispatch) => {
    dispatch({
      type: "GET_FCA_LOADING",
      payload: true,
    });
    CrmCompanyAPI.get(
      `companies/${search_data}?${search_type}=${number}&party_business_id=${party_business_id}&edit_flag=${
        edit_flag ?? ""
      }`
    )
      .then((response) => {
        if (response?.status) {
          dispatch({
            type: "GET_FCA_DETAIL",
            payload: response.data,
            statusCode: 200,
            message: response.data.message_string,
          });
          dispatch({
            type: "GET_FCA_LOADING",
            payload: false,
          });
        } else {
          dispatch({
            type: "GET_FCA_DETAIL",
            statusCode: 400,
            message: response.data?.message_string,
            payload: response.data,
          });
          dispatch({
            type: "GET_FCA_LOADING",
            payload: false,
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: "GET_FCA_DETAIL",
          statusCode: 400,
          message: error?.response?.data?.message_string || "An error occurred",
          details: error?.response?.data?.data,
        });
        dispatch({
          type: "GET_FCA_LOADING",
          payload: false,
        });
      });
  };

export const addToClient =
  ({ companyId, history, brokerCompanyId }) =>
  (dispatch) => {
    dispatch({
      type: "ADD_TO_CLIENT_LOADING",
      payload: true,
    });
    CrmCompanyAPI.post(`companies/${brokerCompanyId}/clients/${companyId}/`)
      .then((response) => {
        dispatch({
          type: "ADD_TO_CLIENT",
          payload: response.data.data,
        });
        dispatch({
          type: "ADD_TO_CLIENT_LOADING",
          payload: false,
        });
        showSuccessMessage(successMessage(response));
        history.push({
          pathname: `/view-client/${companyId}`,
        });
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "ADD_TO_CLIENT_LOADING",
          payload: false,
        });
      });
  };

export const makePortalUser =
  ({ contact_id, data, setOpenModal, companyId }) =>
  (dispatch) => {
    dispatch({
      type: "MAKE_PORTALUSER_LOADING",
      payload: true,
    });
    CrmContactAPI.post(`/${contact_id}/invite`, data)
      .then((response) => {
        dispatch({
          type: "MAKE_PORTALUSER_SUC",
          details: response.data,
        });
        showSuccessMessage(response?.data?.description);
        setOpenModal?.(false);
        dispatch({
          type: "MAKE_PORTALUSER_LOADING",
          payload: false,
        });
        const getUserAuthData = JSON.parse(
          sessionStorage.getItem("loggedUserData")
        );
        const getUserBusinessId =
          getUserAuthData?.user_data?.party_business?.id;

        dispatch(
          getCompanyContact({
            party_business_id: getUserBusinessId,
            company_id: companyId,
            page: data?.row?.pageNo ?? 1,
          })
        );
      })
      .catch((error) => {
        dispatch({
          type: "MAKE_PORTALUSER_FAIL",
          details: error?.response?.data,
        });
        dispatch({
          type: "MAKE_PORTALUSER_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const callActivePortalUser =
  ({ invoffUserId, payload, handleClose, companyId }) =>
  (dispatch) => {
    dispatch({
      type: "ACTIVE_PORTAL_USER_LOADING",
      payload: true,
    });
    const getUserAuthData = JSON.parse(
      sessionStorage.getItem("loggedUserData")
    );
    const getUserBusinessId = getUserAuthData?.user_data?.party_business?.id;
    portalBaseUrl
      .put(`/user/user-profile/${invoffUserId}`, payload)
      .then((response) => {
        handleClose?.();
        dispatch({
          type: "ACTIVE_PORTAL_USER_LOADING",
          payload: false,
        });
        dispatch({
          type: "ACTIVE_PORTAL_USER_SUC",
          details: response.data,
        });
        dispatch(
          getCompanyContact({
            party_business_id: getUserBusinessId,
            company_id: companyId,
          })
        );
      })
      .catch((error) => {
        dispatch({
          type: "ACTIVE_PORTAL_USER_FAIL",
          statusCode: 400,
        });
        dispatch({
          type: "ACTIVE_PORTAL_USER_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };
